import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

export type SectionNavItem = {
    id: string;
    label: string;
    complete?: boolean;
};

type Props = {
    sections: SectionNavItem[];
    activeId?: string;
    onSelect?: (id: string) => void;
};

export function StageSectionNav({ sections, activeId, onSelect }: Props) {
    return (
        <nav className="flex flex-wrap gap-1">
            {sections.map((section, index) => {
                const active = activeId === section.id;
                return (
                    <button
                        key={section.id}
                        type="button"
                        onClick={() => onSelect?.(section.id)}
                        className={cn(
                            "inline-flex items-center gap-1 rounded-md border px-2 py-1 text-xs transition-colors",
                            active
                                ? "border-primary bg-primary/10 text-primary"
                                : "border-transparent bg-muted text-muted-foreground hover:bg-muted/80",
                        )}
                    >
                        <span className="font-mono text-[10px]">{index + 1}</span>
                        {section.label}
                        {section.complete && (
                            <Badge variant="secondary" className="px-1 py-0 text-[9px]">
                                ✓
                            </Badge>
                        )}
                    </button>
                );
            })}
        </nav>
    );
}
